export default "__VITE_ASSET__9ea21682__"